var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListItem',{attrs:{"component":"button","type":"button"},on:{"click":function($event){return _vm.$emit('click', '')}}},[_c('ListItemAction',[_c('LinkIcon',{attrs:{"size":"1.5rem"}})],1),_vm._v(" "),_c('ListItemContent',[_c('ListItemTitle',[_vm._v("Link")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }